module.exports = __webpack_public_path__ + "static/icon-check-1a62a85bc16187d39c2c8599484876a1.jpg";